import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const calendarProductionInboundTollingQueryAtom = createQueryAtomFactory(
  'calendar.productionInboundTolling',
  (params: { fromDate: string; toDate: string; facilityId?: string }) => {
    const filter: Record<string, unknown> = {
      fromEffectiveDate: params.fromDate,
      toEffectiveDate: params.toDate,
    };

    if (params.facilityId) {
      filter.facilityIds = [params.facilityId];
    }

    return {
      inboundTollingAgreements: {
        __args: {
          filter,
          pagination: {
            limit: 500,
            offset: 0,
          },
        },
        entries: {
          id: true,
          agreementNumber: true,
          isActive: true,
          effectiveDate: true,
          expirationDate: true,
          facilityId: true,
          facility: {
            id: true,
            facilityName: true,
          },
        },
        page: {
          total: true,
        },
      },
    };
  },
);
